export const landingId = {
  fixedCtaButtonWrapper: 'landing-fixedCtaButtonWrapper',
};
